(function(app, ng) {

    app.filter("trustAsResourceUrl",
    [
        "$sce", function($sce) {
            return function(val) {
                return $sce.trustAsResourceUrl(val);
            }
        }
    ]);

})(window.app, window.angular); //jshint ignore:line